import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import ReservationActions from '@/actions/ReservationActions';

import ReservationDetails from './ReservationDetails';
import Travelers from './Travelers';
import TermsOfSupplier from './TermsOfSupplier';

import { ReactComponent as CheckmarkIcon } from '@/img/confirmation_page/checkmark.svg';
import ExpediaDealDetailsContainer from '../reservation-payment/components/ExpediaDealDetailsContainer.react';
import { LTR } from 'arbitrip-common/translation/const';

const ConfirmationPage = ({ reservation, hotel, profile }) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const { supplier_ref: supplierRef, id, short_id: shortId, travelers, deal } = reservation;
	const nonRefundable = _.get(reservation, 'deal.dca.nonRefundable');
	const multiLanguageTexts = _.get(reservation, 'deal.original.dca.cancellationPoliciesMultiLanguageTexts');
	const defaultText = _.get(reservation, 'deal.original.dca.cancellationPoliciesText');
	const cancellationPoliciesText = (multiLanguageTexts ? multiLanguageTexts[i18n.language] : defaultText)?.split(
		'\n',
	);
	const city = _.get(hotel, 'city');
	const itineraryId = (supplierRef ? `${supplierRef}` : '').split('-')[0];

	useEffect(() => {
		window.scrollTo(0, 0);

		return () => {
			ReservationActions.clearReservation();
		};
	}, []);

	// var PHONE = t('SupportPhoneNumber');

	return (
		<div className="confirmation-page">
			<div className="order-confirmation">
				<div className="order-confirmation__title">{t('OrderConfirmation')}</div>
				{shortId && city && (
					<div className="order-confirmation__content">
						<CheckmarkIcon />
						<div className="order-confirmation__text">
							{t('ReservationConfirmed', { id: itineraryId ? itineraryId : shortId, city: city })}
						</div>
					</div>
				)}
			</div>
			<div className="confirmation-page__content">
				<div className="confirmation-page__main">
					<Travelers travelers={travelers} bookingId={id} />

					<div className="cancellation-terms">
						<div className="cancellation-terms__content">
							<div className="title">{t('CancellationTerms')}</div>
							<div className="cancellation-terms__text">
								{cancellationPoliciesText.map((line, index) => (
									<div
										key={index}
										className={`cancellation-terms__${
											index === 0 ? (nonRefundable ? 'text-red' : 'text-green') : 'term'
										}`}
									>
										{line.trim()}
									</div>
								))}
							</div>
						</div>
						<div>
							<button
								className="confirmation-page__button"
								onClick={() => navigate('/bookings', { state: { id: id }, replace: true })}
							>
								{t('ViewYourBooking')}
							</button>
						</div>
					</div>

					<TermsOfSupplier deal={deal} />

					<div className="contact-us">
						<div className="contact-us__content">
							<div className="title">{t('ContactUs')}</div>
							<div className="contact-us__text" dir={LTR}>
								{t('ContactUsMessage')} <a href="tel:+13122197193">+1 3122197193</a>.
								{/* TODO: FIX the phone 
                 If you have any questions or need assistance, please don’t hesitate to contact us at any time. We are always happy to help and will respond as soon as possible. You can reach us at <a href={PHONE}>{PHONE}</a> 
                 */}
							</div>
						</div>
					</div>
				</div>

				<div className="confirmation-page__side">
					<ReservationDetails hotel={hotel} reservation={reservation} />
					<ExpediaDealDetailsContainer profile={profile} reservation={reservation} isConfirmation={true} />
				</div>
			</div>
		</div>
	);
};

export default ConfirmationPage;
